var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_405_48)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_405_48",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9048 0H2.09524C0.93807 0 0 0.93807 0 2.09524V13.619C0 14.7762 0.93807 15.7143 2.09524 15.7143H19.9048C21.0619 15.7143 22 14.7762 22 13.619V2.09524C22 0.93807 21.0619 0 19.9048 0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_405_48)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9048 0H2.09524C0.93807 0 0 0.93807 0 2.09524V13.619C0 14.7762 0.93807 15.7143 2.09524 15.7143H19.9048C21.0619 15.7143 22 14.7762 22 13.619V2.09524C22 0.93807 21.0619 0 19.9048 0Z",
    fill: "#FDD200"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H7.33333V15.7143H0V0Z",
    fill: "#002781"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6667 0H22V15.7143H14.6667V0Z",
    fill: "#D0091E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9048 0.523804H2.09524C1.22736 0.523804 0.523811 1.22736 0.523811 2.09523V13.619C0.523811 14.4869 1.22736 15.1905 2.09524 15.1905H19.9048C20.7726 15.1905 21.4762 14.4869 21.4762 13.619V2.09523C21.4762 1.22736 20.7726 0.523804 19.9048 0.523804Z",
    stroke: "black",
    strokeOpacity: 0.1
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_405_48"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 15.7143,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRo);
export default __webpack_public_path__ + "static/media/RO.34505d18001308fb9f645928da3d1aad.svg";
export { ForwardRef as ReactComponent };